

query loginWallet($eth_address: String, $wallet_type: String, $timezone: String, $user_id: String, $hash: String, $email: String, $locale_country: String) {
    loginWallet(eth_address: $eth_address, wallet_type: $wallet_type, timezone: $timezone, user_id: $user_id, hash: $hash, email: $email, locale_country: $locale_country)
}
